import { render, staticRenderFns } from "./IconFinished.vue?vue&type=template&id=255c13eb&scoped=true&lang=pug"
import script from "./IconFinished.vue?vue&type=script&lang=js"
export * from "./IconFinished.vue?vue&type=script&lang=js"
import style0 from "./IconFinished.vue?vue&type=style&index=0&id=255c13eb&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255c13eb",
  null
  
)

export default component.exports